<app-top-nav [pageActions]="navActions">
  <div *ngIf="onPC" class="survey-info">
    <span
      class="address-info"
      pTooltip="{{ addressTitle }}"
      tooltipStyleClass="address-tooltip"
      tooltipPosition="bottom"
      showDelay="300"
    >
      <span class="block" *ngIf="fullBlockAddress">
        {{ fullBlockAddress }}
      </span>
      <span *ngIf="fullBlockAddress && address">&nbsp;|&nbsp;</span>
      <span class="full-address" *ngIf="address">
        <span *ngIf="address as fullAddress">{{
          fullAddress?.getFullAddress()
        }}</span>
        <span *ngIf="buildingKey"> &nbsp;|&nbsp;{{ buildingKey }}</span>
      </span>
    </span>

    <span
      class="surveyor-name"
      pTooltip="
            <mat-icon class='material-icons-outlined'> inventory </mat-icon>
            <span class='title' i18n='@@general.assignedsurveyor'>Assigned Surveyor:&nbsp;</span>
            <span>{{ names.join(' ') }}</span>
        "
      tooltipStyleClass="surveyor-tooltip"
      [escape]="false"
      tooltipPosition="left"
      showDelay="300"
    >
      <mat-icon class="material-icons-outlined"> inventory </mat-icon>
      <span class="initials">{{ initials }}</span>
    </span>

    <div class="kw-logo-wrapper">
      <!-- Needs to be empty -->
    </div>
  </div>
</app-top-nav>
<div class="survey-wrapper">
  <div class="main">
    <ul
      ngbNav
      [activeId]="tabConfig.activeTabId"
      #nav="ngbNav"
      class="nav-tabs nav-fill mobile-overwrite-tabs"
      [class.portrait]="!showTabTitle"
      [destroyOnHide]="tabConfig.destroyOnHide"
      (navChange)="onNavChange($event)"
    >
      <li
        [ngbNavItem]="tabConfig.tabs.valRemarks.id"
        [id]="tabConfig.tabs.valRemarks.id"
        [disabled]="tabConfig.tabs.valRemarks.disabled"
        *ngIf="showValidationRemarksTab"
      >
        <a ngbNavLink>
          <mat-icon class="material-icons-outlined">
            assignment_turned_in
          </mat-icon>
          <span i18n="@@general.validation.remarks.short">Val. Remarks</span>
        </a>
        <ng-template ngbNavContent>
          <div class="survey-container">
            <app-outside-survey-validate-remarks
              *ngIf="survey"
              [survey]="survey"
              [isAuthCanWrite]="isAuthCanWrite"
              #outsideSurveyComponent
            >
            </app-outside-survey-validate-remarks>
          </div>
        </ng-template>
      </li>
      <li
        [ngbNavItem]="tabConfig.tabs.addressInfo.id"
        [id]="tabConfig.tabs.addressInfo.id"
        [disabled]="tabConfig.tabs.addressInfo.disabled"
      >
        <a ngbNavLink>
          <mat-icon class="material-icons-outlined"> room </mat-icon>
          <span *ngIf="showTabTitle" i18n="@@general.address"> Address </span>
        </a>
        <ng-template ngbNavContent>
          <div class="survey-container">
            <app-outside-survey-address
              *ngIf="survey"
              [survey]="survey"
              [isAuthCanWrite]="isAuthCanWrite"
              #outsideSurveyComponent
            >
              <ng-container
                *ngIf="!showTabTitle"
                i18n="@@survey.inside.addressinfo.title.addressinfo"
              >
                Address info
              </ng-container>
            </app-outside-survey-address>
          </div>
        </ng-template>
      </li>
      <li
        [ngbNavItem]="tabConfig.tabs.photos.id"
        [id]="tabConfig.tabs.photos.id"
        [disabled]="tabConfig.tabs.photos.disabled"
      >
        <a ngbNavLink>
          <mat-icon class="material-icons-outlined"> image </mat-icon>
          <mat-icon
            class="errorIcon"
            *ngIf="getErrors(tabConfig.tabs.photos.id)"
            >warning</mat-icon
          >
          <span *ngIf="showTabTitle" i18n="@@general.photo"> Photo </span>
        </a>
        <ng-template ngbNavContent>
          <div class="survey-container">
            <app-outside-survey-photo
              *ngIf="survey"
              [survey]="survey"
              [camera]="camera"
              [cameraLayer]="cameraLayer"
              [isAuthCanWrite]="isAuthCanWrite"
              #outsideSurveyComponent
            >
              <ng-container
                *ngIf="!showTabTitle"
                i18n="@@survey.inside.survey.photo.outside"
              >
                Outside photo info
              </ng-container>
            </app-outside-survey-photo>
          </div>
        </ng-template>
      </li>
      <li
        [ngbNavItem]="tabConfig.tabs.outsideUnits.id"
        [id]="tabConfig.tabs.outsideUnits.id"
        [disabled]="tabConfig.tabs.outsideUnits.disabled"
      >
        <a ngbNavLink>
          <mat-icon class="material-icons-outlined"> home_work </mat-icon>
          <mat-icon
            class="errorIcon"
            *ngIf="getErrors(tabConfig.tabs.outsideUnits.id)"
            >warning</mat-icon
          >
          <span *ngIf="showTabTitle" i18n="@@general.outside.units">
            Outside units
          </span>
        </a>
        <ng-template ngbNavContent>
          <div class="survey-container">
            <app-outside-survey-unit
              *ngIf="survey"
              [survey]="survey"
              [isAuthCanWrite]="isAuthCanWrite"
              #outsideSurveyComponent
            >
              <ng-container
                *ngIf="!showTabTitle"
                i18n="@@general.outside.units"
              >
                Outside Units
              </ng-container>
            </app-outside-survey-unit>
          </div>
        </ng-template>
      </li>
      <li
        [ngbNavItem]="tabConfig.tabs.outsideInfo.id"
        [id]="tabConfig.tabs.outsideInfo.id"
        [disabled]="tabConfig.tabs.outsideInfo.disabled"
      >
        <a ngbNavLink>
          <mat-icon class="material-icons-outlined"> info </mat-icon>
          <mat-icon
            class="errorIcon"
            *ngIf="getErrors(tabConfig.tabs.outsideInfo.id)"
            >warning</mat-icon
          >
          <span *ngIf="showTabTitle" i18n="@@general.outside.outsideinfo">
            Outside info
          </span>
        </a>
        <ng-template ngbNavContent>
          <div class="survey-container">
            <app-outside-survey-technical
              *ngIf="survey"
              [survey]="survey"
              [camera]="camera"
              [cameraLayer]="cameraLayer"
              [isAuthCanWrite]="isAuthCanWrite"
              #outsideSurveyComponent
            >
              <ng-container
                *ngIf="!showTabTitle"
                i18n="@@survey.outside.technical.info.title"
              >
                Technical info
              </ng-container>
            </app-outside-survey-technical>
          </div>
        </ng-template>
      </li>
      <li
        [ngbNavItem]="tabConfig.tabs.contacts.id"
        [id]="tabConfig.tabs.contacts.id"
        [disabled]="tabConfig.tabs.contacts.disabled"
      >
        <a ngbNavLink>
          <mat-icon class="material-icons-outlined"> contact_phone </mat-icon>
          <span *ngIf="showTabTitle" i18n="@@general.contacts"> Contacts </span>
        </a>
        <ng-template ngbNavContent>
          <div class="survey-container">
            <app-outside-survey-contact
              *ngIf="survey"
              [buildingId]="survey.building.id"
              [contacts]="survey.building.persons"
              [isAuthCanWrite]="isAuthCanWrite"
              #outsideSurveyComponent
            >
              <ng-container *ngIf="!showTabTitle" i18n="@@general.contacts">
                Contacts
              </ng-container>
            </app-outside-survey-contact>
          </div>
        </ng-template>
      </li>
      <ng-container *ngIf="validateTabVisible">
        <li
          [ngbNavItem]="tabConfig.tabs.validate.id"
          [id]="tabConfig.tabs.validate.id"
          [disabled]="tabConfig.tabs.validate.disabled"
        >
          <a ngbNavLink>
            <mat-icon class="material-icons-outlined"> verified</mat-icon>
            <span *ngIf="showTabTitle" i18n="@@general.validate">
              Validate
            </span>
          </a>
          <ng-template ngbNavContent>
            <div class="survey-container">
              <app-outside-survey-validate
                *ngIf="survey"
                [survey]="survey"
                [isAuthCanWrite]="isAuthCanWrite"
                [performValidation]="performValidation.bind(this)"
                #outsideSurveyComponent
              >
              </app-outside-survey-validate>
            </div>
          </ng-template>
        </li>
      </ng-container>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
</div>
<div class="hidden full-screen-overlay" #cameraLayer>
  <app-camera #camera></app-camera>
</div>
